import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const SkillsAnalysisChart = ({ data, description }) => {
  // Data preparation for chart
  const departmentsData = () => {
    const departmentCount = {};
    
    // Extract all departments from hired candidates
    data
      .filter(candidate => candidate.stage === 'Hired')
      .forEach(candidate => {
        // Use department field, fallback to role if department not available
        const department = (candidate.department || candidate.role || '').trim();
        if (department) {
          departmentCount[department] = (departmentCount[department] || 0) + 1;
        }
      });
    
    // Convert to array and sort by count
    return Object.entries(departmentCount)
      .map(([department, count]) => ({ department, count }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 10); // Top 10 departments
  };

  // Colors for the bars
  const COLORS = ['#8884d8', '#83a6ed', '#8dd1e1', '#82ca9d', '#a4de6c', '#d0ed57', '#ffc658', '#ff8042', '#ff5252', '#e57373'];

  const chartData = departmentsData();
  
  return (
    <div className="dashboard-card p-6 slide-in-up" style={{animationDelay: '600ms'}}>
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-lg font-semibold text-gray-800">Top Departments Hired</h3>
        <div className="bg-purple-100 text-purple-800 text-xs font-medium px-2.5 py-1 rounded-full">
          Department Analysis
        </div>
      </div>
      {description && (
        <p className="text-sm text-gray-600 mb-4">{description}</p>
      )}
      {chartData.length === 0 ? (
        <div className="flex items-center justify-center h-64 text-gray-500">
          <p>No department data available</p>
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={chartData} layout="vertical" margin={{ top: 5, right: 30, left: 100, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis type="number" tickLine={false} axisLine={false} style={{ fontSize: '12px' }} />
            <YAxis 
              dataKey="department" 
              type="category" 
              tickLine={false} 
              axisLine={false} 
              style={{ fontSize: '12px' }} 
              width={100}
            />
            <Tooltip 
              contentStyle={{ 
                borderRadius: '8px', 
                border: 'none', 
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                fontSize: '12px'
              }} 
              formatter={(value) => [`${value} hires`, 'Count']}
            />
            <Bar 
              dataKey="count" 
              name="Hired Candidates"
              radius={[0, 4, 4, 0]}
              barSize={20}
            >
              {chartData.map((_, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default SkillsAnalysisChart;
